// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import setUserAndAuthToken from 'redux/modules/user/thunks/setUserAndAuthToken'
import lego_authentication_broadcast_channel from 'broadcastChannels/lego_authentication_broadcast_channel'

const prepAndAssignUserData = entity => async dispatch => {
  const {
    contact,
    email,
    defaultUnitType,
    expirationDate,
    firstName,
    jwtToken,
    lastName,
    permissions,
    userId,
    userName,
  } = entity

  const user = {
    contact,
    defaultUnitType,
    email,
    firstName,
    lastName,
    permissions,
    userId,
    userName,
  }

  const userUpdate = {
    authentication: {
      expirationDate,
      jwtToken,
    },
    user,
  }

  // emit update to other UI browser tabs that might be open.
  // the handler on the other side should allow for multiple users to be logged in at the same time.
  lego_authentication_broadcast_channel.postMessage(userUpdate)

  return dispatch(setUserAndAuthToken(userUpdate))
}

export default prepAndAssignUserData
